"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconUploadMultiple = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M56.73 31.39A9.73 9.73 0 0 0 48.62 26c-.33-.15-.67-.29-1-.42a9.75 9.75 0 0 0-6.72-4.75 12.14 12.14 0 0 0-4.29-1.27 12.16 12.16 0 0 0-22 4.35 8.27 8.27 0 0 0-1.33-.11 8.12 8.12 0 0 0 0 16.24h1.26a8.12 8.12 0 0 0 7.6 5.3h.54a8.12 8.12 0 0 0 7.63 5.38h8.12a1.5 1.5 0 0 0 1.5-1.49 1.5 1.5 0 0 0-1.5-1.5H30.3a5.12 5.12 0 1 1 2-9.84 1.5 1.5 0 0 0 2.08-1.31 9.17 9.17 0 0 1 17.74-2.77 1.5 1.5 0 0 0 1.89.89 6.67 6.67 0 0 1 2.17-.36 6.73 6.73 0 0 1 0 13.47h-7.11a1.5 1.5 0 0 0-1.5 1.49 1.5 1.5 0 0 0 1.5 1.5h7.13a9.73 9.73 0 0 0 .53-19.44zm-25.1 3.22a8.27 8.27 0 0 0-1.33-.11 8.12 8.12 0 0 0-8.1 7.86h-.07a5.12 5.12 0 1 1 2-9.84 1.5 1.5 0 0 0 2.08-1.31A9.16 9.16 0 0 1 41.69 25a12.15 12.15 0 0 0-10.06 9.61zm-18.36 2.45a5.12 5.12 0 1 1 2-9.84 1.5 1.5 0 0 0 2.08-1.31 9.15 9.15 0 0 1 15.5-6.14 12.15 12.15 0 0 0-9.41 9.45 8.28 8.28 0 0 0-1.33-.11A8.12 8.12 0 0 0 14 37.06z"
  }), _react["default"].createElement("path", {
    d: "M45.28 41l4.26 4.26a1.5 1.5 0 0 0 2.12-2.12l-6.82-6.82a1.5 1.5 0 0 0-2.12 0l-6.82 6.84a1.5 1.5 0 0 0 2.1 2.12L42.28 41v13.43a1.5 1.5 0 0 0 3 0V41z"
  })),
  height: undefined,
  width: undefined
});
IconUploadMultiple.displayName = 'IconUploadMultiple';
var _default = IconUploadMultiple;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/upload-multiple.js
// module id = 601
// module chunks = 0